import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Button from 'antd/lib/button';
import Modal from 'antd/lib/modal';
import notification from 'antd/lib/notification';
import Select from 'antd/lib/select';
import { updateAlertResolutions } from '../../../../API';
import { config } from '../../../../config';

// ICONS
import { CheckmarkIcon } from '../CheckmarkIcon';

import './CustomResolutionModal.less';

const { REACT_APP_BUILD_ENV } = config;

export const CustomResolutionModal = (props) => {
  const { Option } = Select;

  const { alertForResolution, resolutionOptions, onCancel, onSubmit, theme } = props;
  const { building } = useParams();
  const [selectedResolutions, setSelectedResolutions] = useState([]);

  useEffect(() => {
    const currentAlertResolutions = [];
    alertForResolution.resolutions.forEach((resolution) => currentAlertResolutions.push(resolution.name));
    setSelectedResolutions(currentAlertResolutions);
  }, []);

  const submitCustomResolution = async () => {
    const { resolutions } = alertForResolution;
    const updatedResolutions = [];
    const currentResolutionNames = [];

    // Set up the removed resolutions to also be removed in the request to the API
    resolutions.forEach((resolution) => {
      if (!selectedResolutions.includes(resolution.name)) {
        updatedResolutions.push({ name: null, slug: resolution.slug, is_removed: true });
      }
    });

    // Create a list of existing alert resolution names
    resolutions.forEach((resolution) => currentResolutionNames.push(resolution.name));

    // Add the new resolutions to the request to the API
    selectedResolutions.forEach((resolution) => {
      if (!currentResolutionNames.includes(resolution)) {
        updatedResolutions.push({ name: resolution, slug: null, is_removed: false });
      }
    });

    const response = await updateAlertResolutions(
      REACT_APP_BUILD_ENV,
      building,
      alertForResolution.incident_uid_hash,
      alertForResolution.uid_hash,
      updatedResolutions,
    );

    if (response === true) {
      // Handle success
      notification.info({
        className: `alerts-resolution-notification alerts-resolution-notification-${theme}`,
        placement: 'topRight',
        duration: 5,
        icon: <CheckmarkIcon theme={theme} />,
        message: 'Resolution successfully added!',
      });
      onSubmit();
    } else {
      notification.info({
        className: `alerts-resolution-notification alerts-resolution-notification-${theme}`,
        placement: 'topRight',
        duration: 5,
        icon: <CheckmarkIcon theme={theme} />,
        message: 'We encountered an error while trying to add this resolution. Please try again.',
      });
    }
  };

  return (
    <Modal
      className={`alerts-overview-resolution-modal alerts-overview-resolution-modal-${theme}`}
      centered
      open
      keyboard
      title="Update resolution"
      footer={null}
      onCancel={onCancel}
    >
      <div className="alerts-overview-resolution-modal__select-container">
        <span className="alerts-overview-resolution-modal__description">
          Select from the list or create a custom tag:
        </span>
        <Select
          className="alerts-overview-resolution-modal__select"
          mode="tags"
          value={selectedResolutions}
          onChange={(value) => setSelectedResolutions(value)}
        >
          {resolutionOptions.map((resolution) => {
            return <Option key={resolution.name}>{resolution.name}</Option>;
          })}
        </Select>
      </div>
      <Button size="large" className="alerts-overview-resolution-modal__button" onClick={submitCustomResolution}>
        <span className="alerts-overview-resolution-modal__button-text">Update</span>
      </Button>
    </Modal>
  );
};
